import { Avatar, TextInput } from '@mantine/core';
// icons
import { X, SendHorizontal } from 'lucide-react';
// utils
import { cn } from '@/utils';

interface ChatPreviewProps {
    name: string;
    pictureUrl: string;
    greetingPhrase: string;
    color: string;
}

const ChatPreview = ({
    name,
    pictureUrl,
    greetingPhrase,
    color
}: ChatPreviewProps) => {
    const mainColor = color || '#000000';
    return (
        <div>
            <div
                className={cn(
                    'flex items-center gap-2 p-2 text-xs font-semibold text-white rounded-t-lg'
                )}
                style={{ backgroundColor: mainColor }}
            >
                <Avatar bg="white" size="sm" src={pictureUrl} />
                {name}
                <X className="text-white ml-auto text-lg" />
            </div>
            <div className="flex flex-col gap-4 p-2 pt-40 bg-white border-1 border-gray-3 rounded-b-lg">
                <div className="flex gap-2">
                    <Avatar
                        bg="gray.1"
                        className="shrink-0"
                        size="sm"
                        src={pictureUrl}
                    />
                    <div className="text-sm leading-tight whitespace-pre-wrap break-words">
                        {greetingPhrase}
                    </div>
                </div>
                <TextInput
                    className="w-full"
                    placeholder="Type your message here..."
                    rightSection={<SendHorizontal />}
                />
            </div>
        </div>
    );
};

export default ChatPreview;
